export const CARD_BORDER_VARIANTS = [
    'primary',
    'success',
    'warning',
    'danger',
    'info',
    'secondary',
    'request-blue',
    'request-indigo',
    'request-violet',
    'request-pink',
    'request-rose',
    'request-red',
    'request-orange',
    'request-amber',
    'request-lime',
    'request-green',
    'request-teal',
    'request-cyan',
    'request-sky',
    'request-slate'
];

const LEGACY_CARD_BORDER_COLOR_VARIANTS = {
    '#007bff': 'primary',
    '#28a745': 'success',
    '#ffc107': 'warning',
    '#dc3545': 'danger',
    '#17a2b8': 'info',
    '#6c757d': 'secondary',
    '#6610f2': 'request-violet',
    '#6f42c1': 'request-violet',
    '#e83e8c': 'request-pink',
    '#fd7e14': 'request-orange'
};

export function normalizeCardBorderVariant(value, legacyColor) {
    const variant = String(value || '').trim();
    if (CARD_BORDER_VARIANTS.includes(variant)) {
        return variant;
    }

    const color = String(legacyColor || '').trim().toLowerCase();
    return LEGACY_CARD_BORDER_COLOR_VARIANTS[color] || 'primary';
}
